const { FeedStreamRecord } = require('client-v2/common/containers/feed/records')

module.exports = FeedStreamRecord
